import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { useUIContext } from 'state/ui';

import { Price } from './price';

interface IModifierPriceProps {
  price: number;
}

/** @deprecated Use Product instead */
const ModifierPrice: FC<IModifierPriceProps> = ({ price }) => {
  const { formatMessage } = useIntl();
  const { formatCurrencyForLocale } = useUIContext();
  const priceString = formatMessage(
    { id: 'price' },
    {
      price: formatCurrencyForLocale(price),
    }
  );
  return price > 0 ? <Price data-testid="modifier-upcharge">{priceString}</Price> : null;
};

export default ModifierPrice;
